<div class="element" [id]="element._id" [class.active]="editorActive">
  <div class="status" [style.backgroundColor]="status.color">

    <!-- Options -->
    <div class="icon">
      <sg2-element-options
        *ngIf="authService.canRead('element-contextmenu')"
        class="menu"
        [element]="element"
        [options]="['assignTo', 'delete', 'edit', 'restoreParagraph', 'setStatus', 'showLogs']">
      </sg2-element-options>
    </div>

    <div class="icons">
      <!-- Assigned user -->
      <div *ngIf="authService.canRead('element-assignment')" >
        <sg2-user-icon class="user" [element]="element" [animated]="'fadeIn'"></sg2-user-icon>
      </div>
      <!-- Comments -->
      <div class="comments" *ngIf="element.commentCount && authService.canRead('element-comment')" (click)="showLogs()">
        <span class="badge">{{ element.commentCount }}</span>
        <mat-icon [matTooltip]="getCommentTooltip()" matTooltipPosition="above">comment</mat-icon>
      </div>
      <!-- Instruction -->
      <div class="instructions" *ngIf="element.hasInputInstruction && authService.canUpdate('element')">
        <mat-icon [matTooltip]="element.inputInstruction" matTooltipPosition="above">info</mat-icon>
      </div>
    </div>

  </div>
  <div class="text">

    <!-- Chapter title -->
    <h3>
      <span [class.muted]="!element.chapter">
        <span *ngIf="element.chapter">{{ element.chapter }}.&nbsp;</span>
        <span [attr.contenteditable]="authService.canUpdate('element')"
          (keydown.enter)="submitTitle($event)"
          (blur)="submitTitle($event)">{{ element.name }}
        </span>
      </span>
      <span class="restore a"
        *ngIf="edited" 
        [matTooltip]="'Deze paragraaf is niet gelijk aan de templatewaarde'"
        matTooltipPosition="above"
        (click)="restoreTemplateValue()">
        {{ 'edited' | translate }}
      </span>
    </h3>

    <!-- Displayed element value (readonly) -->
    <!-- <div class="base" [innerHTML]="value | safeHtml" (mouseenter)="authService.canUpdate('element') && setActive()"></div> -->
    <div class="base"
      [innerHTML]="value | safeHtml"
      (mouseenter)="authService.canUpdate('element') && editInline() && activateInline()"
      (click)="authService.canUpdate('element') && !editInline() && openModal()">
    </div>

    <!-- Editor component -->
    <div class="editor" *ngIf="editorActive">
      <ng-container *ngTemplateOutlet="editor"></ng-container>
    </div>

  </div>
  <div class="right">

  </div>
</div>

<!-- Ng-template for Lazy loading the editor -->
<ng-template #editor>
  <editor [init]="tinyMCEConfig" [(ngModel)]="value" [inline]="true" (onBlur)="submitValue()" cloudChannel="5-stable"></editor>
</ng-template>
